import React from 'react';
import { SummaryRow as Row, StatColumn as Item } from './style';
import { Text } from '../../../UI/Text';
import { Icon } from '../../../Components/Icons/Icons';

export const SummaryStats = ({ roundsNumber, calories, distance, time, weight, reps, toggleSettings }) => {
    return (
        <Row>
            <div className={'display-desktop'}>
                <Item>
                    <Value>{roundsNumber}</Value>
                    <Description>Rounds</Description>
                </Item>
            </div>

            <div className={'display-desktop'}>
                <Item>
                    <Value>{calories}</Value>
                    <Description>Calories</Description>
                </Item>
            </div>

            <div className={'display-desktop'}>
                <Item>
                    <Value>{distance}</Value>
                    <Description>KM</Description>
                </Item>
            </div>

            <Item>
                <Value>{time}</Value>
                <Description>Length</Description>
            </Item>

            <div className={'display-desktop'}>
                <Item>
                    <Value>{weight}</Value>
                    <Description>KG Lifted</Description>
                </Item>
            </div>

            <div className={'display-desktop'}>
                <Item>
                    <Value>{reps}</Value>
                    <Description>Reps</Description>
                </Item>
            </div>
            <Icon.Box onClick={toggleSettings} cursor={'pointer'} size={'24x24'}>
                <Icon.Settings />
            </Icon.Box>
        </Row>
    );
};

const Value = ({ children }) => <Text weight={'bold'}>{children}</Text>;

const Description = ({ children }) => (
    <Text weight={200} marginTop={'3px'} fontSize={11} opacity={0.6}>
        {children}
    </Text>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/SummaryStats.js